export default "__VITE_ASSET__d6a241cb__"